import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

// -----------------------------------------------------------

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 2560.000000 2560.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN}
          stroke="none"
          strokeWidth="1"
          fillRule="evenodd"
          transform="translate(0.000000,2560.000000) scale(0.100000,-0.100000)"
        >
          <path d="M2121 13854 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
          <path
            d="M15575 7540 c-181 -39 -285 -147 -285 -294 0 -81 18 -122 77 -176 56
-51 64 -55 306 -126 63 -19 107 -47 107 -70 0 -8 -9 -23 -20 -34 -24 -24 -73
-26 -155 -5 -66 17 -245 102 -245 116 0 5 -4 9 -10 9 -9 0 -120 -210 -120
-227 0 -5 8 -13 19 -18 10 -6 45 -24 77 -41 137 -73 342 -107 482 -80 189 35
286 134 285 291 -1 155 -71 222 -303 290 -69 21 -137 44 -152 51 -30 16 -38
50 -16 72 29 29 149 5 295 -59 40 -18 75 -31 77 -28 2 2 27 53 56 113 40 85
48 111 38 118 -33 24 -127 62 -192 79 -81 22 -262 32 -321 19z"
          />
          <path
            d="M7932 7068 l3 -473 133 -3 c72 -1 132 1 132 5 0 4 1 118 1 252 0 166
4 240 11 233 5 -5 49 -97 97 -203 l87 -194 102 0 103 0 75 170 c122 278 109
279 112 -12 l2 -253 135 0 135 0 0 475 0 475 -164 0 -164 0 -39 -82 c-22 -46
-73 -156 -113 -245 -41 -90 -77 -163 -81 -163 -3 0 -23 37 -44 83 -21 45 -69
145 -106 223 -36 77 -70 150 -73 162 -7 21 -11 22 -177 22 l-169 0 2 -472z"
          />
          <path
            d="M9350 7153 c-234 -557 -230 -547 -230 -555 0 -4 71 -8 158 -8 l157 0
24 65 23 65 180 -2 181 -3 21 -60 21 -60 163 -3 c110 -2 162 1 162 8 0 10
-227 577 -270 675 -9 22 -37 91 -61 152 l-44 113 -161 0 -161 0 -163 -387z
m364 -62 c25 -71 46 -131 46 -135 0 -3 -43 -6 -95 -6 -52 0 -95 4 -95 9 0 5
18 60 40 123 22 62 42 119 45 126 2 6 6 12 8 12 3 0 25 -58 51 -129z"
          />
          <path
            d="M10262 7068 l3 -473 133 -3 132 -3 1 228 c1 125 1 235 0 245 -6 54
25 3 105 -175 l90 -202 84 -3 c91 -3 130 2 130 19 0 5 13 38 29 72 15 34 47
105 70 157 83 186 76 195 79 -90 l2 -250 135 0 135 0 0 475 0 475 -163 0 -163
0 -51 -107 c-122 -256 -161 -342 -168 -362 -3 -11 -10 -21 -14 -21 -7 0 -168
334 -214 443 l-20 47 -168 0 -169 0 2 -472z"
          />
          <path
            d="M11520 7064 l0 -476 273 4 c261 4 275 6 338 30 214 80 319 226 319
442 0 234 -126 400 -346 456 -67 17 -111 20 -331 20 l-253 0 0 -476z m475 225
c49 -14 107 -74 123 -128 15 -48 15 -144 2 -193 -25 -89 -90 -131 -205 -132
l-80 -1 -3 220 c-1 121 0 225 2 232 7 16 105 17 161 2z"
          />
          <path
            d="M12757 7363 c-42 -98 -91 -216 -110 -263 -19 -47 -74 -177 -121 -289
-47 -113 -86 -209 -86 -213 0 -5 71 -7 157 -6 l157 3 24 63 24 62 178 0 179 0
20 -55 c12 -31 21 -60 21 -65 0 -6 66 -10 165 -10 91 0 165 4 165 8 0 11 -97
262 -110 285 -6 9 -30 68 -55 130 -24 61 -82 204 -127 317 l-83 205 -161 3
-161 2 -76 -177z m283 -295 c21 -59 35 -110 32 -113 -3 -3 -45 -5 -94 -5 -68
0 -88 3 -88 14 0 11 24 79 86 246 7 18 10 11 64 -142z"
          />
          <path
            d="M13410 7415 l0 -125 135 0 135 0 0 -350 0 -350 155 0 155 0 0 350 0
350 135 0 135 0 0 125 0 125 -425 0 -425 0 0 -125z"
          />
          <path
            d="M14507 7478 c-110 -267 -309 -740 -341 -812 -14 -32 -26 -63 -26 -67
0 -6 69 -8 158 -7 l157 3 24 63 25 62 180 -2 181 -3 20 -60 21 -60 162 -3
c102 -1 162 1 162 7 0 6 -66 174 -146 373 -81 200 -164 409 -187 466 l-40 102
-162 0 -162 0 -26 -62z m228 -388 c25 -68 45 -127 45 -132 0 -4 -43 -8 -95 -8
-52 0 -95 4 -95 9 0 16 92 262 96 258 3 -2 24 -59 49 -127z"
          />
          <path
            d="M16162 7218 c4 -287 7 -328 23 -368 60 -143 165 -226 327 -256 94
-18 210 -8 301 26 80 30 165 111 203 192 l29 63 3 333 3 332 -155 0 -156 0 0
-297 c0 -338 -3 -352 -73 -387 -53 -25 -101 -15 -149 34 l-38 38 0 306 0 306
-161 0 -161 0 4 -322z"
          />
          <path
            d="M17175 7528 c-3 -7 -4 -220 -3 -473 l3 -460 283 -3 c311 -3 371 5
464 55 52 28 100 80 119 129 6 16 11 54 12 86 1 99 -65 196 -158 233 -18 7
-17 9 11 20 44 19 101 87 114 136 32 119 -57 232 -216 273 -81 21 -622 24
-629 4z m516 -234 c7 -9 13 -31 13 -50 0 -53 -23 -64 -129 -61 l-90 2 -3 63
-3 62 99 0 c79 0 102 -3 113 -16z m20 -353 c26 -32 24 -67 -6 -96 -22 -23 -31
-25 -125 -25 l-100 0 0 68 c0 38 3 72 8 76 4 4 51 6 105 4 90 -3 101 -5 118
-27z"
          />
        </g>
      </svg>
    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>;
}
